import { render, staticRenderFns } from "./Drive.vue?vue&type=template&id=0089ccf0&scoped=true"
import script from "./Drive.vue?vue&type=script&lang=js"
export * from "./Drive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089ccf0",
  null
  
)

export default component.exports